module.exports = __webpack_public_path__ + "img/57.c6634c21.png";